import state from './state';

export default {
  objektart: () => state.allgemeineAngaben.objektart,
  ermittlungsstichtag: () => state.allgemeineAngaben.ermittlungsstichtag,
  baujahr: () => state.allgemeineAngaben.baujahr,
  kernsanierung: () => state.allgemeineAngaben.kernsanierung,
  jahrDerKernsanierung: () => state.allgemeineAngaben.jahrDerKernsanierung,
  wohnungsnummer: () => state.allgemeineAngaben.wohnungsnummer,
  anzahlWohneinheiten: () => state.allgemeineAngaben.anzahlWohneinheiten,
  anzahlNutzeinheiten: () => state.allgemeineAngaben.anzahlNutzeinheiten,
  wohnflaeche: () => state.allgemeineAngaben.wohnflaeche,
  nutzflaeche: () => state.allgemeineAngaben.nutzflaeche,
  isValid: () => state.allgemeineAngaben.valid(),

  aussenwaendeModernisierung: () => state.aussenwaende.modernisierung,
  aussenwaendeJahrDerModernisierung: () => state.aussenwaende.jahrDerModernisierung,
  aussenwaendeErlaeuterung: () => state.aussenwaende.erlaeuterung,
  aussenwaendeAussenansichtVorne: () => state.aussenwaende.fotos.aussenansichtVorne,
  aussenwaendeAussenansichtHinten: () => state.aussenwaende.fotos.aussenansichtHinten,
  aussenwaendeOffensichtlicheSchaeden: () => state.aussenwaende.fotos.offensichtlicheSchaeden,
  aussenwaendeZusatzfoto: () => state.aussenwaende.fotos.zusatzfoto,
  isAussenwaendeValid: () => state.aussenwaende.valid(),

  dachModernisierung: () => state.dach.modernisierung,
  dachJahrDerModernisierung: () => state.dach.jahrDerModernisierung,
  dachErlaeuterung: () => state.dach.erlaeuterung,
  dachDacheindeckungAussen: () => state.dach.fotos.dacheindeckungAussen,
  dachDachgeschossInnen: () => state.dach.fotos.dachgeschossInnen,
  dachOffensichtlicheSchaeden: () => state.dach.fotos.offensichtlicheSchaeden,
  dachZusatzfoto: () => state.dach.fotos.zusatzfoto,
  isDachValid: () => state.dach.valid(),

  fensterModernisierung: () => state.fenster.modernisierung,
  fensterJahrDerModernisierung: () => state.fenster.jahrDerModernisierung,
  fensterErlaeuterung: () => state.fenster.erlaeuterung,
  fensterHauseingangstuer: () => state.fenster.fotos.hauseingangstuer,
  fensterFenster: () => state.fenster.fotos.fenster,
  fensterOffensichtlicheSchaeden: () => state.fenster.fotos.offensichtlicheSchaeden,
  fensterZusatzfoto: () => state.fenster.fotos.zusatzfoto,
  isFensterValid: () => state.fenster.valid(),

  fussboedenModernisierung: () => state.fussboeden.modernisierung,
  fussboedenJahrDerModernisierung: () => state.fussboeden.jahrDerModernisierung,
  fussboedenErlaeuterung: () => state.fussboeden.erlaeuterung,
  fussboedenFussboden1: () => state.fussboeden.fotos.fussboden1,
  fussboedenFussboden2: () => state.fussboeden.fotos.fussboden2,
  fussboedenFussboden3: () => state.fussboeden.fotos.fussboden3,
  fussboedenOffensichtlicheSchaeden: () => state.fussboeden.fotos.offensichtlicheSchaeden,
  fussboedenZusatzfoto: () => state.fussboeden.fotos.zusatzfoto,
  isFussboedenValid: () => state.fussboeden.valid(),

  innenwaendeModernisierung: () => state.innenwaende.modernisierung,
  innenwaendeJahrDerModernisierung: () => state.innenwaende.jahrDerModernisierung,
  innenwaendeErlaeuterung: () => state.innenwaende.erlaeuterung,
  innenwaendeInnentuer1: () => state.innenwaende.fotos.innentuer1,
  innenwaendeInnentuer2: () => state.innenwaende.fotos.innentuer2,
  innenwaendeInnenwand1: () => state.innenwaende.fotos.innenwand1,
  innenwaendeInnenwand2: () => state.innenwaende.fotos.innenwand2,
  innenwaendeInnenwand3: () => state.innenwaende.fotos.innenwand3,
  innenwaendeOffensichtlicheSchaeden: () => state.innenwaende.fotos.offensichtlicheSchaeden,
  innenwaendeZusatzfoto: () => state.innenwaende.fotos.zusatzfoto,
  isInnenwaendeValid: () => state.innenwaende.valid(),

  deckenModernisierung: () => state.decken.modernisierung,
  deckenJahrDerModernisierung: () => state.decken.jahrDerModernisierung,
  deckenErlaeuterung: () => state.decken.erlaeuterung,
  deckenTreppe1: () => state.decken.fotos.treppe1,
  deckenTreppe2: () => state.decken.fotos.treppe2,
  deckenDeckenkonstruktion1: () => state.decken.fotos.deckenkonstruktion1,
  deckenDeckenkonstruktion2: () => state.decken.fotos.deckenkonstruktion2,
  deckenOffensichtlicheSchaeden: () => state.decken.fotos.offensichtlicheSchaeden,
  deckenZusatzfoto: () => state.decken.fotos.zusatzfoto,
  isDeckenValid: () => state.decken.valid(),

  sanitaerModernisierung: () => state.sanitaer.modernisierung,
  sanitaerJahrDerModernisierung: () => state.sanitaer.jahrDerModernisierung,
  sanitaerErlaeuterung: () => state.sanitaer.erlaeuterung,
  sanitaerBad1: () => state.sanitaer.fotos.bad1,
  sanitaerBad2: () => state.sanitaer.fotos.bad2,
  sanitaerOffensichtlicheSchaeden: () => state.sanitaer.fotos.offensichtlicheSchaeden,
  sanitaerZusatzfoto: () => state.sanitaer.fotos.zusatzfoto,
  isSanitaerValid: () => state.sanitaer.valid(),

  heizungModernisierung: () => state.heizung.modernisierung,
  heizungJahrDerModernisierung: () => state.heizung.jahrDerModernisierung,
  heizungErlaeuterung: () => state.heizung.erlaeuterung,
  heizungHeizungsanlage1: () => state.heizung.fotos.heizungsanlage1,
  heizungHeizungsanlage2: () => state.heizung.fotos.heizungsanlage2,
  heizungOffensichtlicheSchaeden: () => state.heizung.fotos.offensichtlicheSchaeden,
  heizungZusatzfoto: () => state.heizung.fotos.zusatzfoto,
  isHeizungValid: () => state.heizung.valid(),

  technischeAusstattungModernisierung: () => state.technischeAusstattung.modernisierung,
  technischeAusstattungJahrDerModernisierung: () => state.technischeAusstattung.jahrDerModernisierung,
  technischeAusstattungErlaeuterung: () => state.technischeAusstattung.erlaeuterung,
  technischeAusstattungSicherungskasten: () => state.technischeAusstattung.fotos.sicherungskasten,
  technischeAusstattungSteckdose: () => state.technischeAusstattung.fotos.steckdosen,
  technischeAusstattungOffensichtlicheSchaeden: () => state.technischeAusstattung.fotos.offensichtlicheSchaeden,
  technischeAusstattungZusatzfoto: () => state.technischeAusstattung.fotos.zusatzfoto,
  isTechnischeAusstattungValid: () => state.technischeAusstattung.valid(),

  objektunterlagenGrundriss: () => state.objektunterlagen.grundriss,
  objektunterlagenZusatzdokumentGrundriss: () => state.objektunterlagen.zusatzdokumentGrundriss,
  objektunterlagenEnergieausweis: () => state.objektunterlagen.energieausweis,
  objektunterlagenZusatzdokumentEnergieausweis: () => state.objektunterlagen.zusatzdokumentEnergieausweis,
  isObjektunterlagenValid: () => state.objektunterlagen.valid(),

  ansprechpartnerNachname: () => state.ansprechpartner.nachname,
  ansprechpartnerVorname: () => state.ansprechpartner.vorname,
  ansprechpartnerTelefon: () => state.ansprechpartner.telefon,
  ansprechpartnerErlaeuterung: () => state.ansprechpartner.erlaeuterung,
  isAnsprechpartnerValid: () => state.ansprechpartner.valid(),

  defaultRechnungName1: () => state.defaultRechnung.name1,
  defaultRechnungName2: () => state.defaultRechnung.name2,
  defaultRechnungPlz: () => state.defaultRechnung.plz,
  defaultRechnungOrt: () => state.defaultRechnung.ort,
  defaultRechnungStr: () => state.defaultRechnung.str,
  defaultRechnungHnr: () => state.defaultRechnung.hnr,
  isDefaultRechnungValid: () => state.defaultRechnung.valid(),

  alternativeRechnungName1: () => state.alternativeRechnung.name1,
  alternativeRechnungName2: () => state.alternativeRechnung.name2,
  alternativeRechnungPlz: () => state.alternativeRechnung.plz,
  alternativeRechnungOrt: () => state.alternativeRechnung.ort,
  alternativeRechnungStr: () => state.alternativeRechnung.str,
  alternativeRechnungHnr: () => state.alternativeRechnung.hnr,
  useDefaultRechnung: () => state.alternativeRechnung.useDefault,
  isAlternativeRechnungValid: () => state.alternativeRechnung.valid(),

  isStillUploading() {
    function streamToBoolean(path) {
      return Object.values(path)
        .flatMap(a => a)
        .map(file => file?.isStillUploading())
        .reduce((a, b) => a || b);
    }

    const aussenwaende = streamToBoolean(state.aussenwaende.fotos);
    const dach = streamToBoolean(state.dach.fotos);
    const fenster = streamToBoolean(state.fenster.fotos);
    const fussboeden = streamToBoolean(state.fussboeden.fotos);
    const innenwaende = streamToBoolean(state.innenwaende.fotos);
    const decken = streamToBoolean(state.decken.fotos);
    const sanitaer = streamToBoolean(state.sanitaer.fotos);
    const heizung = streamToBoolean(state.heizung.fotos);
    const technischeAusstattung = streamToBoolean(state.technischeAusstattung.fotos);
    const objektunterlagen = streamToBoolean({
      a: state.objektunterlagen.energieausweis,
      b: state.objektunterlagen.zusatzdokumentEnergieausweis,
      c: state.objektunterlagen.grundriss,
      d: state.objektunterlagen.zusatzdokumentGrundriss,
    });
    return (
      aussenwaende ||
      dach ||
      fenster ||
      fussboeden ||
      innenwaende ||
      decken ||
      sanitaer ||
      heizung ||
      technischeAusstattung ||
      objektunterlagen
    );
  },
  exportData: () => {
    let unwrap = ({ modernisierung, jahrDerModernisierung, erlaeuterung }) => ({
      modernisierung,
      jahrDerModernisierung,
      erlaeuterung,
    });
    return {
      allgemeineAngaben: (({
        ermittlungsstichtag,
        baujahr,
        wohnungsnummer,
        anzahlWohneinheiten,
        anzahlNutzeinheiten,
        wohnflaeche,
        nutzflaeche,
        kernsanierung,
        jahrDerKernsanierung,
      }) => ({
        ermittlungsstichtag,
        baujahr,
        wohnungsnummer,
        anzahlWohneinheiten,
        anzahlNutzeinheiten,
        wohnflaeche,
        nutzflaeche,
        kernsanierung,
        jahrDerKernsanierung,
      }))(state.allgemeineAngaben),
      aussenwaende: unwrap(state.aussenwaende),
      dach: unwrap(state.dach),
      fenster: unwrap(state.fenster),
      fussboeden: unwrap(state.fussboeden),
      innenwaende: unwrap(state.innenwaende),
      decken: unwrap(state.decken),
      sanitaer: unwrap(state.sanitaer),
      heizung: unwrap(state.heizung),
      technischeAusstattung: unwrap(state.technischeAusstattung),
      ansprechpartner: (({ telefon, erlaeuterung }) => ({
        telefon,
        erlaeuterung,
      }))(state.ansprechpartner),
      alternativeRechnung: (({
        name1,
        name2,
        plz,
        ort,
        str,
        hnr,
        useDefault
      }) => ({
        name1,
        name2,
        plz,
        ort,
        str,
        hnr,
        useDefault
      }))(state.alternativeRechnung),
    };
  },
  ausSpeicherGeladen: () => state.ausSpeicherGeladen,
};
